module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-08.0ef4be30.png";